import { singleCustomObjectProvisioningStateSelector } from "components/ProvisioningStateDot/ProvisioningState.selectors";
import StatusBadge from "components/StatusBadge";
import Tooltip from "components/Tooltip/Tooltip";
import { getCustomObjectProvisioningStateColors } from "config/ts-utils";
import { CustomObjectProvisioningState } from "graphql/generated/graphql";
import { useSelector } from "react-redux";
import { capitalizeFirstLetter } from "utils/utils";
import styles from "./ProvisioningStateDot.module.scss";

export interface ProvisioningStateData {
    id: string;
    provisioning_state: CustomObjectProvisioningState;
    object_template_id_object_template: {
        id: string;
        icon: string;
    };
}

export const ProvisioningStateDot = ({
    id,
    wrapperClassName,
}: {
    id: string;
    wrapperClassName?: string;
}) => {
    const provisioningStateData: ProvisioningStateData = useSelector(
        singleCustomObjectProvisioningStateSelector(id)
    );

    const provisioningState = provisioningStateData?.provisioning_state;
    const stateText = capitalizeFirstLetter(
        provisioningState?.toLowerCase().replace("_", " ") ?? ""
    );

    // A READY custom object shows no dot: the dot signals a noteworthy
    // (non-READY) lifecycle state. The backend omits READY states from the live
    // channel, so an absent store entry also means READY -- both render nothing.
    if (!provisioningState || provisioningState === "READY") {
        return null;
    }
    return (
        <div className={`${styles.provisioningStateDotWrapper} ${wrapperClassName ?? ""}`}>
            <Tooltip overlay={stateText} overlayStyle={{ zIndex: 20000 }}>
                <StatusBadge
                    round
                    type={getCustomObjectProvisioningStateColors(provisioningState)}
                    size="small"
                />
            </Tooltip>
        </div>
    );
};
